module.exports = __webpack_public_path__ + "static/media/responsabilite-civile.9f9fd7cd.svg";